import { render } from "./ClientInvoices.vue?vue&type=template&id=54d9480c&scoped=true"
import script from "./ClientInvoices.vue?vue&type=script&lang=js"
export * from "./ClientInvoices.vue?vue&type=script&lang=js"

import "./ClientInvoices.vue?vue&type=style&index=0&id=54d9480c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d9480c"]])

export default __exports__